import React from 'react';
import PropTypes from 'prop-types';
import ChartBar from '../ChartBar';
import ChartLine from '../ChartLine';
import './chartTheme';

export default function ChartKit(props) {
    const { type = 'bar', ...rest } = props;

    if (type === 'line') {
        const lineProps = {
            className: rest.className || rest.classNameWrapp,
            chartData: rest.chartData,
            yAxesLeft: rest.yAxesLeft,
            yAxesRight: rest.yAxesRight,
            parameters: rest.parameters,
            loading: rest.loading,
            getMetrics: rest.getMetrics,
            height: rest.height,
            area: false,
        };
        return <ChartLine {...lineProps} />;
    }

    const barProps = {
        classNameWrapp: rest.classNameWrapp || rest.className || '',
        classNameCanvas: rest.classNameCanvas || '',
        height: rest.height,
        yAxesLeft: rest.yAxesLeft,
        yAxesRight: rest.yAxesRight,
        loading: rest.loading,
        chartData: rest.chartData,
        parameters: rest.parameters,
        getMetrics: rest.getMetrics,
    };
    return <ChartBar {...barProps} />;
}

ChartKit.propTypes = {
    type: PropTypes.oneOf(['bar', 'line']),
    classNameWrapp: PropTypes.string,
    classNameCanvas: PropTypes.string,
    className: PropTypes.string,
    height: PropTypes.number,
    yAxesLeft: PropTypes.string,
    yAxesRight: PropTypes.string,
    loading: PropTypes.bool,
    chartData: PropTypes.shape({
        labels: PropTypes.array,
        metricsData: PropTypes.object,
    }),
    parameters: PropTypes.object,
    getMetrics: PropTypes.func,
};


